<meta charset="utf-8">
<div class="container-fluid p-3 div-bg">
  <div class="row">
    <div class="col-12 col-md-8 d-flex flex-column align-items-center text-center mb-4">
      <div class="w-100">
        <div class="language-dropdown mb-3">
          <!-- Language switch (optional) -->
        </div>

        <div class="h5">{{placeHolders['LBL_WELCOME_TO']}}</div>

        <img [src]="postlogoUrl" class="img-fluid my-3 shadow rounded" style="max-width: 200px;">

        <div class="pt-2 fw-medium fs-5">
          {{placeHolders['LBL_ONE_STOP_ADV']}} {{countryName}}
        </div>

        <img [src]="countrylogoUrl" class="img-fluid my-3" style="height: 100px;">

        <div class="pt-3 div-18">{{placeHolders['LBL_MANAGE_DEALS']}}</div>

        <div class="pt-1">{{placeHolders['PARA_BELOW_CREATE_DEALS_SEAMLESSLY_CREATE']}}</div>
      </div>
    </div>

    <div class="col-12 col-md-4 mt-5">
      <form [formGroup]="logInForm" (keydown.enter)="logIn()" class="p-3 border rounded shadow-sm bg-white">
        <div class="div-14 ">
          <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/58865303-9ae8-4b3b-842b-ffd2f48ca140?" class="img-fluid mb-2" style="max-width: 60px;">
          <div class="fw-bold" style="color: whitesmoke;">{{placeHolders['NEW_MERCHANT']}}</div>
          <button (click)="navigateToRegister()" type="button" class="btn btn-primary btn-white btn-sm">{{placeHolders['REGISTER_HERE']}}</button>
        </div>
        <span class="div-18">{{placeHolders['LOGIN']}} </span>

        <div class="mb-3 pt-2">
          <label for="emaillogin" class="form-label asterix">{{placeHolders['EMAIL']}}</label>
          <input id="emaillogin" type="text" class="form-control" placeholder="{{placeHolders['ENTER_EMAIL']}}"
            formControlName="email_id" (input)="trimWhitespace('email_id')"  pattern="[a-zA-Z0-9._%+\u00C0-\u017F-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
            [ngClass]="{ 'is-invalid': f['email_id'].errors && (f['email_id'].dirty || f['email_id'].touched ) }">
          <div class="invalid-feedback" *ngIf="f['email_id'].errors && (f['email_id'].dirty || f['email_id'].touched )">
            <div *ngIf="f['email_id'].errors['required']">{{placeHolders['MSG_EMAIL_REQUIRED']}}</div>
            <div *ngIf="f['email_id'].errors['pattern']">{{placeHolders['INVALID']}}!!</div>
          </div>
        </div>

        <div class="mb-3">
          <label for="passowordlogin" class="form-label asterix">{{placeHolders['PASSWORD']}}</label>
          <div class="input-group">
            <input [type]="show ? 'text' : 'password'" id="passowordlogin" placeholder="{{placeHolders['ENTER_PASSWORD']}}"
              class="form-control" formControlName="password"
              [ngClass]="{ 'is-invalid': f['password'].errors && (f['password'].dirty || f['password'].touched ) }">
            <span class="input-group-text" (click)="togglePasswordVisibility()" style="cursor: pointer;">
              <mat-icon>{{show ? 'visibility_off' : 'visibility'}}</mat-icon>
            </span>
          </div>
          <div class="invalid-feedback" *ngIf="f['password'].errors && (f['password'].dirty || f['password'].touched)">
            <div *ngIf="f['password'].errors['required']">{{placeHolders['MSG_PASSWORD_REQUIRED']}}</div>
          </div>
        </div>

        <div class="mb-3 text-end">
          <a class="text-decoration-none" routerLink="/forgetPassword">{{placeHolders['FORGOT_PASSWORD']}}</a>
        </div>

        <button class="btn btn-success w-100" (click)="logIn()">{{placeHolders['LOGIN']}}</button>
      </form>
    </div>
  </div>

  <ngx-ui-loader fgsColor="#93d847" [logoUrl]="faviconLogo" fgsType="rotating-plane" pbColor="#93d847"
    text="{{placeHolders['LBL_LODER_SETTNG_UP_THINGS']}}"></ngx-ui-loader>
</div>
